export const content = (root) => root
